<script setup lang="ts">
import { computed } from 'vue'
import { Handle, Position } from '@vue-flow/core'
import { useI18n } from 'vue-i18n'

const props = defineProps<{ type: string; data: { label?: string } }>()
const { t } = useI18n()
const handlePositions = [Position.Top, Position.Right, Position.Bottom, Position.Left]
const classes = computed(() => ({
  'rounded-full border-2 border-emerald-600 bg-emerald-50': props.type === 'start',
  'rounded-full border-2 border-slate-600 bg-slate-100': props.type === 'end',
  'rounded-md border-2 border-blue-500 bg-blue-50': props.type === 'activity',
  'pm-flow-decision': props.type === 'decision',
  'rounded-md border-2 border-violet-500 bg-violet-50': props.type === 'document',
  'rounded-md border-2 border-teal-500 bg-teal-50 shadow-inner': props.type === 'process',
}))
</script>

<template>
  <div class="relative min-w-28 max-w-52 px-4 py-3 text-center text-xs font-medium text-slate-800" :class="[classes, type !== 'decision' && 'shadow-sm']">
    <svg v-if="type === 'decision'" class="pointer-events-none absolute inset-0 h-full w-full overflow-visible" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      <polygon points="50,0 100,50 50,100 0,50" fill="#fffbeb" stroke="#f59e0b" stroke-width="2" vector-effect="non-scaling-stroke" />
    </svg>
    <span class="relative block break-words">{{ data?.label || type }}</span>
    <Handle
      v-for="position in handlePositions"
      :id="position"
      :key="position"
      type="source"
      :position="position"
      class="pm-flow-handle"
      :title="t('processManagement.flowConnectionPoint')"
      :aria-label="t('processManagement.flowConnectionPoint')"
    />
  </div>
</template>

<style scoped>
.pm-flow-decision {
  min-width: 144px;
  min-height: 88px;
  padding: 28px 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
